import React from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Grid,
  Chip,
  Divider,
  Card,
  CardHeader,
  CardContent
} from "@mui/material";

const VendorDashboard = () => {
  // Sample data for the dashboard
  const recentActivity = [
    { id: 121, updatedTime: '2 hours ago', status: 'Approved' },
    { id: 122, updatedTime: '2 hours ago', status: 'Approved' },
    { id: 123, updatedTime: '2 hours ago', status: 'Approved' },
  ];

  return (
    <div className="page-container">
      <Card
        className="shadow-sm"
        variant="outlined"
        sx={{
          border: "1px solid lightgray",
          borderRadius: "10px",
          width: "100%",
        }}
      >
        <CardHeader
          title={<Typography variant="h5" sx={{ fontWeight: 400, fontSize: '24px', color: '#333' }} className="font-rubik">Dashboard</Typography>}
          action={
            <div>
              <Button
                variant="outlined"
                sx={{
                  marginRight: "8px",
                  backgroundColor: "#050092",
                  color: "#fff",
                  fontWeight: 400,


                }}
                className="font-rubik"
              >
                New Order
              </Button>
            </div>
          }
          sx={{
            margin: "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        />
        <Divider sx={{ backgroundColor: "darkgray" }} />
      
      <CardContent>

      <Grid container spacing={3}>
        {/* Active Orders Card */}
        <Grid item xs={12} md={4}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              borderRadius: '8px',
              height: '100%',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              border: '1px solid #f0f0f0'
            }}
          >
            <Typography variant="subtitle1" color="text.secondary" gutterBottom sx={{ fontFamily: 'Rubik' }}>
              Active Orders
            </Typography>
            <Typography component="div" sx={{ color: '#4F46E5', fontSize: '38px', fontWeight: 'Semibold', my: 1, fontFamily: 'Rubik' }}>
              12
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Rubik' }}>
              3 pending approval
            </Typography>
          </Paper>
        </Grid>

        {/* Outstanding Invoices Card */}
        <Grid item xs={12} md={4}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              borderRadius: '10px',
              height: '100%',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)'
            }}
          >
            <Typography variant="subtitle1" color="text.secondary" gutterBottom sx={{ fontFamily: 'Rubik' }}>
              Outstanding Invoices
            </Typography>
            <Typography component="div" sx={{ color: '#4F46E5',fontSize: '38px', fontWeight: 'Semibold', my: 1, fontFamily: 'Rubik' }}>
              45,250,34
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Rubik' }}>
              Last 30 days
            </Typography>
          </Paper>
        </Grid>

        {/* Quality Score Card */}
        <Grid item xs={12} md={4}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              borderRadius: '10px',
              height: '100%',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)'
            }}
          >
            <Typography variant="subtitle1" color="text.secondary" gutterBottom sx={{ fontFamily: 'Rubik' }}>
              Quality Score
            </Typography>
            <Typography component="div" sx={{ color: '#10B981', fontSize: '38px', fontWeight: 'Semibold', my: 1, fontFamily: 'Rubik' }}>
              98%
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Rubik' }}>
              Above target
            </Typography>
          </Paper>
        </Grid>

        {/* Recent Activity Section */}
        <Grid item xs={12}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              borderRadius: '8px',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              border: '1px solid #f0f0f0'
            }}
          >
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }} className="font-montserrat">
              Recent Activity
            </Typography>
            
            {recentActivity.map((activity, index) => (
              <Box key={activity.id} sx={{ mb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'medium', fontFamily: 'Rubik' }}>
                      Purchase Order #{activity.id}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Rubik' }}>
                      Updated {activity.updatedTime}
                    </Typography>
                  </Box>
                  <Chip 
                    label={activity.status} 
                    sx={{ 
                      bgcolor: '#DCFCE7', 
                      color: '#10B981',
                      fontWeight: 'medium',
                      borderRadius: '16px'
                    }} 
                  />
                </Box>
                {index < recentActivity.length - 1 && (
                  <Box sx={{ borderBottom: '1px solid #EEEEEE', my: 2 }} />
                )}
              </Box>
            ))}
          </Paper>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
    </div>
  );
};

export default VendorDashboard;
